import { render, staticRenderFns } from "./CategoryAdmin.vue?vue&type=template&id=507846dc&"
import script from "./CategoryAdmin.vue?vue&type=script&lang=js&"
export * from "./CategoryAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CategoryAdmin.vue"
export default component.exports